<template>
  <div class="container mx-auto max-w-7xl mb-[-20vh]">
    <main class="p-4 overflow-auto max-h-[70vh] scroll">
      <div v-for="(post, i) in selectedPagePost" :key="i" class="p-5">
        <div class="flex items-center text-sm">
          <el-icon>
            <Calendar/>
          </el-icon>
          <span class="ml-1.5">
            {{ post.frontMatter.date }}
          </span>
        </div>
        <header class="my-3 ">
          <h1>
            <span
                class="articleTitle"
                @click="redirectTo(post.regularPath)"
            >
              {{ post.frontMatter.title }}
            </span>
          </h1>
        </header>
        <el-divider/>
        <div class="line-clamp-3 my-3 text-gray-500 dark:text-gray-400 indent-8 vp-doc" v-html="post.content"/>
        <div class="flex ">
          <div class="flex items-center text-sm mt-3">
            <el-icon>
              <Folder/>
            </el-icon>
            <span class="ml-1.5">
              {{ post.frontMatter.folder }}
            </span>
          </div>
          <div class="flex justify-end mr-3 ml-auto">
            <button class="moreBtn"
                    @click="redirectTo(post.regularPath)">
              閱讀全文
            </button>
          </div>
        </div>
        <el-divider/>
      </div>
    </main>
    <div class="justify-center flex mt-3">
      <el-pagination
          :current-page="currentPage"
          :page-size="10"
          :total="AllPosts.length"
          layout="prev, pager, next"
          small
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref, toRefs} from "vue";
import {useData} from "vitepress";
import chunk from "lodash/chunk";
import {CategoryType, IPost} from "../type";

const props = defineProps<{
  category: CategoryType;
}>();

const {category} = toRefs(props);

const {theme} = useData();
const AllPosts: IPost[] = theme.value.posts[category.value] ?? [];
//分頁
const currentPage = ref(1);
let chunkPosts: IPost[][] = chunk(AllPosts, 10);
const selectedPagePost = ref(chunkPosts[currentPage.value - 1]);
const handleCurrentChange = (changeEvent: number): void => {
  currentPage.value = changeEvent;
  selectedPagePost.value = chunkPosts[changeEvent - 1];
};

const redirectTo = (url: string): void => {
  window.location.href = url;
};
</script>
<style lang="scss" scoped>
.articleTitle {
  @apply text-4xl font-semibold border-0 border-b-red-900
  transition-all duration-150 ease-linear
  dark:border-b-red-800
  hover:font-bold hover:cursor-pointer hover:drop-shadow hover:text-brand-1 hover:border-b-2
  hover:dark:text-red-800 hover:dark:drop-shadow-[0px_0px_1px_rgba(255,255,255,.15)]
}

:deep(.vp-doc) {
  h2, h3 {
    border-top: 0;
    margin: 0;
    padding-top: 0
  }
}

.moreBtn {
  border: .5px solid #B91C1C;
  @apply mt-3 bg-transparent transition border-brand-1 hover:bg-brand-1 text-brand-1
        text-xs font-semibold hover:text-white py-1 px-3 rounded hover:border-transparent
}

* {
  scroll-behavior: smooth;
  word-break: break-word;

  &::-webkit-scrollbar {
    width: 8px;

    &-thumb {
      background-color: #c0c4cd;
      border-radius: 14px;
      border: 3px solid #c0c4cd;
    }

    &-track {
      background: #091e4214;
      border-radius: 5px;

      .dark & {
        background: #2d2d2d;
        border-radius: 5px;
      }
    }
  }
}
</style>
